import { useAuthClient } from "@/shared/lib/authClient";
import {
	AuthFormFeaturesLib,
	AuthFormFeaturesModel,
	AuthFormFeaturesUi
} from "@features/AuthFormFeatures";
import { zodResolver } from "@hookform/resolvers/zod";
import { useRouter } from "next/router";
import { useForm } from "react-hook-form";

function SignInWidget() {
	const signInFormApi = useForm<AuthFormFeaturesModel.ISignInSchema>({
		resolver: zodResolver(AuthFormFeaturesModel.signInSchema)
	});
	const navigate = useRouter();
	const authClient = useAuthClient();
	return (
		<AuthFormFeaturesUi.AuthFormRoot formApi={signInFormApi}>
			<AuthFormFeaturesUi.AuthFormContainer
				onSubmit={signInFormApi.handleSubmit(
					AuthFormFeaturesLib.registerSubmitSignInForm(
						signInFormApi,
						navigate,
						authClient
					)
				)}
			>
				<AuthFormFeaturesUi.AuthFormHeader
					title="Login or create an account"
					subTitle="Enter your email below to login to your account"
				/>
				<div className="grid gap-6">
					<AuthFormFeaturesUi.AuthFormField
						control={signInFormApi.control}
						name={"email"}
						type={"email"}
						DisplayName="Email"
					/>
					<AuthFormFeaturesUi.AuthFormField
						control={signInFormApi.control}
						name={"password"}
						type={"password"}
						DisplayName="Password"
					/>
					<AuthFormFeaturesUi.SubmitAuthFormFeature />
					<AuthFormFeaturesUi.SignInAuthMethods />
					<AuthFormFeaturesUi.AuthFormErrorMessage />
				</div>
			</AuthFormFeaturesUi.AuthFormContainer>
		</AuthFormFeaturesUi.AuthFormRoot>
	);
}

export default SignInWidget;
